import React, { useEffect, useId, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import './ConfirmDialog.css';

/**
 * Modal de confirmação no estilo do painel Admin.
 */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  tone = 'danger',
  busy = false,
  onConfirm,
  onCancel,
}) => {
  const titleId = useId();
  const confirmRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.activeElement;
    confirmRef.current?.focus();

    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onCancel?.();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      if (prev && typeof prev.focus === 'function') prev.focus();
    };
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div
      className="admin-confirm"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel?.();
      }}
    >
      <div
        className={`admin-confirm__card admin-confirm__card--${tone}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <header className="admin-confirm__head">
          <h2 id={titleId}>{title}</h2>
          <button
            type="button"
            className="admin-btn admin-btn--ghost admin-btn--sm"
            onClick={onCancel}
            disabled={busy}
            aria-label="Fechar"
          >
            <FaTimes aria-hidden="true" />
          </button>
        </header>
        <p className="admin-confirm__body">{message}</p>
        <div className="admin-confirm__actions">
          <button
            type="button"
            className="admin-btn admin-btn--ghost"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            ref={confirmRef}
            type="button"
            className={`admin-btn ${
              tone === 'primary' ? 'admin-btn--primary' : 'admin-btn--danger'
            }`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Aguarde…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
